import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { compose } from "redux"
import { withTranslation } from "react-i18next"

import InputField from "@material-ui/core/TextField"
import { Typography } from "@material-ui/core"
import withStyles from "@material-ui/core/styles/withStyles"

import { parseValidationString } from "../../../utils/helpers/validation"

import styles from "./styles"

const TextField = ({
    t,
    tReady,
    input: { value, onChange, onBlur, onFocus },
    required,
    defaultValue,
    label,
    meta,
    classes,
    endAdornment,
    startAdornment,
    i18n,
    defaultNS,
    i18nOptions,
    reportNS,
    variant,
    labelEndAdornment,
    disableUnderline,
    helperText,
    errorText,
    ...formControlProps
}) => (
    <Fragment>
        {(label || labelEndAdornment) && (
            <div className={classes.labelContainer}>
                <Typography className={classes.aboveLabel} variant="body1">
                    {label}
                    {required && <span>&nbsp;*</span>}
                </Typography>
                {labelEndAdornment}
            </div>
        )}
        <InputField
            classes={{ root: classes.formControl }}
            InputLabelProps={{ shrink: true }}
            InputProps={{
                classes: {
                    root: classes.textField,
                },
                endAdornment,
                startAdornment,
                disableUnderline,
            }}
            autoComplete={label.replace("_", "-")}
            value={value || defaultValue || ""}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            error={meta.touched && !!meta.error}
            helperText={
                (!errorText || (errorText && !meta.touched)) &&
                ((meta.touched &&
                    meta.error &&
                    t(...parseValidationString(meta.error))) ||
                    helperText)
            }
            variant={variant}
            FormHelperTextProps={{ classes: { contained: classes.error } }}
            {...formControlProps}
        />
        {meta.touched && errorText && (
            <div className={classes.errorContainer}>
                <Typography className={classes.error} variant="caption">
                    {errorText}
                </Typography>
            </div>
        )}
    </Fragment>
)

TextField.propTypes = {
    t: PropTypes.func.isRequired,
    label: PropTypes.string,
    classes: PropTypes.exact({
        labelContainer: PropTypes.string,
        formControl: PropTypes.string,
        aboveLabel: PropTypes.string,
        textField: PropTypes.string,
        error: PropTypes.string,
        errorContainer: PropTypes.string,
    }).isRequired,
    defaultValue: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
    input: PropTypes.shape({
        value: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
    }),
    startAdornment: PropTypes.element,
    endAdornment: PropTypes.element,
    labelEndAdornment: PropTypes.element,
    required: PropTypes.bool,
    // Translations props
    tReady: PropTypes.bool,
    i18n: PropTypes.any,
    defaultNS: PropTypes.any,
    i18nOptions: PropTypes.any,
    reportNS: PropTypes.any,
    variant: PropTypes.oneOf(["standard", "outlined", "filled"]),
    disableUnderline: PropTypes.bool,
    helperText: PropTypes.oneOf([PropTypes.node, PropTypes.string]),
    errorText: PropTypes.string,
}

TextField.defaultProps = {
    defaultValue: null,
    meta: {
        touched: false,
        error: null,
    },
    label: "",
    input: {},
    startAdornment: null,
    endAdornment: null,
    labelEndAdornment: null,
    required: false,
    // Translations props
    tReady: false,
    i18n: null,
    defaultNS: null,
    i18nOptions: null,
    reportNS: null,
    variant: "outlined",
    disableUnderline: false,
    helperText: null,
    errorText: null,
}

export default compose(
    withStyles(styles, { name: "TextField" }),
    withTranslation(),
    React.memo,
)(TextField)
